<template>
  <div>
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <FilterCliente :onChange="changeFilter"/>
      <md-card>
        <md-card-header class="hide-mobile" data-background-color="newyellow">
          <div style="display: flex;align-items: center;">
            <md-icon class="configicon">people</md-icon>
            <h4 class="tittle">Clientes</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <tabela-clientes :atividades="selectAtv" :personas="selectPrs" :analistas="selectAnl" :arquivos="selectArq"/>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>

import TabelaClientes from "../components/Clientes/tabelaClientes";
import FilterCliente from "../components/Common/FilterCliente"

export default {
  components:{
      TabelaClientes,
      FilterCliente
  },

  data() {
    return {
      selectAtv: [],
      selectPrs: [],
      selectAnl: [],
      selectArq: []
    };
  },

  methods: {
    changeFilter(selectAtv, selectPrs, selectAnl, selectArq) {
      this.selectAtv = selectAtv; 
      this.selectPrs = selectPrs;
      this.selectAnl = selectAnl;
      this.selectArq = selectArq;
    }
  }
}
</script>
<style scoped>
.configicon {
  width: 20px;
  margin: 3px;
  margin-right: 19px;
  color: #fff !important;
  font-size: 36px !important;
}
</style>
